module.exports = __webpack_public_path__ + "img/46_13.baa7941f.png";